import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function AppInitializerFactory(translate: TranslateService): () => void {
  return (): void => {
    const languages: string[] = ['de'];
    const browserLang: string | undefined = translate.getBrowserLang();

    translate.addLangs(languages);
    translate.setDefaultLang('de');

    translate.use(browserLang?.match(/de/) ? browserLang : 'de');
  };
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + new Date().getTime());
}
